
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/cloud",
      function () {
        return require("private-next-pages/services/cloud.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/cloud"])
      });
    }
  